import React from 'react'
import { GoogleReCaptchaContext } from 'react-google-recaptcha-v3'

export const useRecaptchaLoaded = () => {
  // executeRecaptcha is a function that will be available after the reCAPTCHA script was loaded
  const { executeRecaptcha } = React.useContext(GoogleReCaptchaContext)

  return !!executeRecaptcha
}
